<template>
  <div class="sc-weather">
    <main-info v-if="currentWeather" :currentWeather="currentWeather" />
    <additional-info v-if="currentWeather" :currentWeather="currentWeather" />
  </div>
</template>

<script>
import {
  getDatetime,
  getWeatherUrls,
  getWeatherIconName
} from "../../../configs";
import mainInfo from "./components/main";
import additionalInfo from "./components/additional";

export default {
  components: { mainInfo, additionalInfo },
  data() {
    return {
      city: this.$store.state.situationCenter.config.city,
      timeZone: this.$store.state.situationCenter.config.timeZone,
      isLoading: false,
      refreshData: null,
      currentWeather: null,
      currentHour: null,
      currentDate: null,

      getWeatherIconName
    };
  },
  methods: {
    async getWeather() {
      if (!getWeatherUrls(this.city)) return;
      const dateTime = getDatetime(this.timeZone);
      this.currentHour = Number(dateTime.getHours());
      this.currentDate = Number(dateTime.getDate());
      let currentWeather;

      try {
        const currentWeatherResponse = await fetch(
          getWeatherUrls(this.city)[1]
        );
        currentWeather = await currentWeatherResponse.json();

        this.isLoading = false;
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }

      this.setCurrentWeather(currentWeather);
    },
    getTemp(value) {
      const temp = Math.trunc(value);

      return temp > 0 ? `+${temp}` : temp;
    },
    getDate(value) {
      return Number(
        value
          .split(" ")[0]
          .split("-")
          .pop()
      );
    },
    getHour(value) {
      return Number(
        value
          .split(" ")
          .pop()
          .split(":")[0]
      );
    },
    setCurrentWeather(value) {
      let temp, id, name, humidity, wind, visibility;

      if (value) {
        temp =
          value.main.temp || value.main.temp === 0
            ? this.getTemp(value.main.temp)
            : 0;
        id = value.weather[0].id ? value.weather[0].id : null;
        name = value.weather[0].main ? value.weather[0].main : null;
        humidity = value.main.humidity ? value.main.humidity : null;
        wind = value.wind && value.wind.speed ? value.wind.speed : null;
        visibility = value.visibility ? value.visibility / 1000 : null;
      }

      const currentWeather = {
        icon: getWeatherIconName(id, this.currentHour),
        temp,
        id,
        name,
        humidity,
        wind,
        visibility
      };

      this.currentWeather = currentWeather;
    }
  },
  created() {
    this.isLoading = true;
    this.getWeather();
    this.refreshData = setInterval(this.getWeather, 300000);
    this.clientHeight = document.documentElement.clientHeight;
    window.addEventListener(
      "resize",
      () => {
        this.clientHeight = document.documentElement.clientHeight;
      },
      false
    );
  },
  beforeDestroy() {
    clearInterval(this.refreshData);
  }
};
</script>

<style lang="scss" scoped>
.sc-weather {
  padding-top: 8px;
  border-top: 1px solid;
  border-color: var(--dividers_low_contrast) !important;
  > div {
    margin-bottom: 8px;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
